import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CardIconTitle } from '../CardIconTitle/CardIconTitle'
import { TrendingUpIcon } from '../../assets/icons/trending-up'
import { colors } from '../../theme'
import {
  ContainerCard,
  Div,
  Wrapper,
} from '../../pages/PredictionDetails/PredictionDetails.style'
import { useModulosTenant } from '../../hooks/useModulosTenant'
import { getMixContagem } from '../../services/MixService/getMixRecomendacoes'
import { SemDados } from './MixRecomendacoes.style'

/**
 * Chamariz do Mix Inteligente no detalhe do cliente/predicao: aparece SÓ quando o modulo esta
 * DESLIGADO no tenant e o cliente tem oportunidades. Mostra a contagem sem expor o conteudo do Mix,
 * para incentivar a contratacao. E o inverso de {@link MixRecomendacoes} (que aparece com o Mix ON);
 * renderizados lado a lado, exatamente um dos dois aparece.
 */
export function MixChamariz() {
  const { id } = useParams()
  const { moduloMixInteligenteAtivo, carregado } = useModulosTenant()
  const [total, setTotal] = useState(0)

  useEffect(() => {
    // So consulta depois de resolver os modulos e apenas com o Mix desligado (evita chamada e
    // "flash" do chamariz enquanto o /me nao respondeu).
    if (!carregado || moduloMixInteligenteAtivo || !id) {
      setTotal(0)
      return undefined
    }
    let ativo = true
    const buscar = async () => {
      const result = await getMixContagem([Number(id)])
      if (!ativo || 'message' in result) return
      setTotal(result[Number(id)] ?? 0)
    }
    buscar()
    return () => {
      ativo = false
    }
  }, [carregado, moduloMixInteligenteAtivo, id])

  if (!carregado || moduloMixInteligenteAtivo || total <= 0) {
    return null
  }

  return (
    <Div>
      <Wrapper size="100">
        <ContainerCard>
          <CardIconTitle
            icon={<TrendingUpIcon />}
            background={colors.secondary}
            title="Oportunidades de venda"
          />
        </ContainerCard>
        <SemDados>
          <strong>{total}</strong>{' '}
          {total === 1 ? 'oportunidade de venda' : 'oportunidades de venda'}{' '}
          para este cliente — conheça o Mix Inteligente para vê-las em detalhe.
        </SemDados>
      </Wrapper>
    </Div>
  )
}
